import { createSelector } from 'reselect';
import type { CustomizablePdfDeal, FuelSavingData, PdfVehicle } from '@makemydeal/dr-platform-types';
import type { PrintingCustomization } from '@makemydeal/dr-sales-checkin-types';
import { ApiRequestStatus } from '@makemydeal/dr-shared-types';
import { ProposalLayoutType } from '../../types';
import { hasCommonVehicle } from '../../utils/proposalUtils';
import { NO_DEALS } from './constants';
import type { RootStateWithDealProposal } from './types';

export const getDealProposalFetchStatus = (state: RootStateWithDealProposal): ApiRequestStatus =>
    state.dealProposal?.requestStatus ?? ApiRequestStatus.Idle;

export const getDeals = (state: RootStateWithDealProposal): CustomizablePdfDeal[] => state.dealProposal?.deals ?? NO_DEALS;

export const getPrintConfig = (state: RootStateWithDealProposal): PrintingCustomization | undefined =>
    state.dealProposal?.printConfig;

export const hasSingleVehicle = createSelector(getDeals, hasCommonVehicle);

export const getLayoutType = (state: RootStateWithDealProposal): ProposalLayoutType =>
    hasSingleVehicle(state) ? ProposalLayoutType.SINGLE_COLUMN : ProposalLayoutType.MULTI_COLUMN;

export const getDefaultActiveScenario = (state: RootStateWithDealProposal): CustomizablePdfDeal | undefined => {
    const deals = getDeals(state);
    return deals.find(({ isPrimaryScenario }) => isPrimaryScenario) ?? deals[0];
};

const getFirstDeal = (state: RootStateWithDealProposal): CustomizablePdfDeal => getDeals(state)[0];

export const getFuelSavingData = (state: RootStateWithDealProposal): FuelSavingData | undefined =>
    hasSingleVehicle(state) ? getFirstDeal(state).fuelSavingData : undefined;

export const getVehicle = (state: RootStateWithDealProposal): PdfVehicle | undefined =>
    hasSingleVehicle(state) ? getFirstDeal(state).vehicle : undefined;
